import { SingpassUserData } from './singpassTypes.ts';

/**
 * Per business requirements - SG applications must use a Singapore residential address. Always force the
 * application country to Singapore. If Singpass omits the address country field, do
 * not prefill the partial address it returns... empty values allow the applicant
 * to enter and edit their complete address manually.
 */
export function normalizeSingpassUserData(userData: SingpassUserData): SingpassUserData {
  const hasAddressCountry = Boolean(userData.address?.country?.trim());

  return {
    ...userData,
    address: {
      ...(hasAddressCountry
        ? userData.address
        : {
            line1: '',
            line2: '',
            city: '',
            postcode: '',
          }),
      country: 'SG',
    },
  };
}
